const actions = {
    FETCH_EXERCISES: 'FETCH_EXERCISES',
    FETCH_EXERCISES_SUCCESS: 'FETCH_EXERCISES_SUCCESS',
    FETCH_EXERCISES_FAIL: 'FETCH_EXERCISES_FAIL',

    OPEN_ROUTINE_EXERCISES: 'OPEN_ROUTINE_EXERCISES',
    CLOSE_ROUTINE_EXERCISES: 'CLOSE_ROUTINE_EXERCISES',
}

export default actions